import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { PropsWithChildren } from 'react';
import { NAVBAR } from '@/config';
import useCollapseDrawer from '@/hooks/useCollapseDrawer';
import { NavBarItemsDrawer } from '@/layouts/dashboard/navbar/NavBarItemsDrawer';

type MainStyleProps = {
  collapseHover: boolean;
};

const MainStyle = styled('main', {
  shouldForwardProp: (prop) => prop !== 'collapseHover',
})<MainStyleProps>(({ collapseHover, theme }) => ({
  flexGrow: 1,
  [theme.breakpoints.up('lg')]: {
    paddingLeft: 16,
    paddingRight: 16,
    width: `calc(100% - ${NAVBAR.DASHBOARD_WIDTH}px)`,
    transition: theme.transitions.create('margin-left', {
      duration: theme.transitions.duration.shorter,
    }),
    marginLeft: collapseHover ? NAVBAR.DASHBOARD_COLLAPSE_WIDTH : NAVBAR.DASHBOARD_WIDTH,
  },
}));

export const NavBar = ({ children }: PropsWithChildren) => {
  const { collapseHover } = useCollapseDrawer();

  return (
    <Box
      key={'navbar'}
      sx={{
        minHeight: 1,
        display: 'flex',
      }}
    >
      <NavBarItemsDrawer />
      <MainStyle collapseHover={collapseHover} sx={{ pb: 6 }}>
        {children}
      </MainStyle>
    </Box>
  );
};
